module.exports = __webpack_public_path__ + "img/up-arrow.6e7f3646.svg";